var React = require('react');

function ChairOffice (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M352 256H96V64a64 64 0 0 1 64-64h128a64 64 0 0 1 64 64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M64 224v-64a32 32 0 0 0-64 0v64a32 32 0 0 0 64 0zm352-96a32 32 0 0 0-32 32v64a32 32 0 0 0 64 0v-64a32 32 0 0 0-32-32zm-12.33 181.88A32 32 0 0 0 373.31 288H74.69a32 32 0 0 0-30.36 21.88l-10.67 32A32 32 0 0 0 64 384h128v67.36c-28.27 6-51 19.69-61.85 37.21-6.41 10.34 2.41 23.43 15 23.43h157.68c12.61 0 21.44-13.09 15-23.43-10.83-17.52-33.57-31.2-61.83-37.21V384h128a32 32 0 0 0 30.36-42.12z","className":"fa-primary","key":2})]);
}

ChairOffice.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ChairOffice;

ChairOffice.default = ChairOffice;
